import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux'
import { lightTheme } from './theme';
import { UserContextProvider } from 'contexts/UserContext';
import store from 'store';
import routes from 'routes';
import HomePage from 'routes/HomePage';
import SavesPage from 'routes/SavesPage';
import GamePage from 'routes/GamePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <UserContextProvider>
        <ThemeProvider theme={lightTheme}>
          <Routes>
            <Route path={routes.root}>
              <Route index element={<HomePage />} />
              <Route path={routes.games.root}>
                <Route path={routes.games.saves}>
                  <Route index element={<SavesPage />} />
                  <Route path="*" element={<GamePage />} />
                </Route>
                <Route index element={<GamePage />}/>
              </Route>
              <Route path="*" element={<div>Page Not Found!</div>} />
            </Route>
          </Routes>
        </ThemeProvider>
      </UserContextProvider>
    </Provider>

  </BrowserRouter>
);
